module.exports = __webpack_public_path__ + "static/media/Servicos5.31aea55c.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/CadServicos/Servicos5.png
// module id = 2120
// module chunks = 0